/**
 * The AP control screens' route table (design C3 §5.9, §6.5).
 *
 * Exported as `AP_C3_ROUTES` and mounted by **P9** in `web/src/router/index.ts`.
 * A separate file from `routes.ts` because that one holds *path builders* — the
 * links AP documents use to reach each other — and the pre-C3 AP routes are
 * declared inline in the router itself. Adding a new export is one line for P9;
 * moving twelve existing records out of the router to make room would be a
 * conflict with whatever else is in flight.
 */

import type { RouteRecordRaw } from 'vue-router'

import { AP_PERMISSIONS } from '@/modules/ap/permissions'

export const AP_C3_ROUTES: RouteRecordRaw[] = [
  {
    path: '/ap/signals',
    name: 'ap-signals',
    component: () => import('@/modules/ap/SignalInboxView.vue'),
    meta: { titleKey: 'ap.routeTitles.signals', permission: AP_PERMISSIONS.signalRead },
  },
  {
    path: '/ap/payment-exceptions',
    name: 'ap-payment-exceptions',
    component: () => import('@/modules/ap/PaymentExceptionsView.vue'),
    meta: { titleKey: 'ap.routeTitles.paymentExceptions', permission: AP_PERMISSIONS.paymentRead },
  },
]
